import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=615b5219&scoped=true&"
import script from "./Todos.vue?vue&type=script&lang=js&"
export * from "./Todos.vue?vue&type=script&lang=js&"
import style0 from "./Todos.vue?vue&type=style&index=0&id=615b5219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b5219",
  null
  
)

export default component.exports